<ng-container *ngIf="planActivationSummary$ | async as summary; else loading">
  <div class="row">
    <div class="col-xl-8">
      <div class="card mt-4 ms-4">
        <div class="card-body pt-4">
          <div class="d-flex justify-content-between border-bottom pb-2">
            <h2>Purchase Plan</h2>
          </div>
          <div class="row pt-5">
            <div class="col-lg-12">
              <!--<h4 class="col-lg-12 text-lg-center py-4">Plan details</h4>-->
              <div class="row">
                <p class="col-lg-6 text-lg-end">Plan:</p>
                <p class="col-lg-6 fw-bold">{{ summary.plan.name }}</p>
              </div>
              <div class="row">
                <p class="col-lg-6 text-lg-end">Price:</p>
                <p class="col-lg-6 fw-bold">
                  {{
                    summary.plan.price
                      | currency: summary.billingSummary.currency : 'symbol' : '1.2-2'
                  }}
                  / User
                </p>
              </div>
              <div *ngIf="summary.plan.discount > 0" class="row">
                <p class="col-lg-6 text-lg-end">Discounted Price:</p>
                <p class="col-lg-6 fw-bold">
                  {{
                    summary.plan.discountedPrice
                      | currency: summary.billingSummary.currency : 'symbol' : '1.2-2'
                  }}
                  / User
                </p>
              </div>
              <div class="row">
                <p class="col-lg-6 text-lg-end">Billing Frequency:</p>
                <p class="col-lg-6 fw-bold">{{ summary.plan.billingFrequency | capitalize }}</p>
              </div>
              <!-- <div class="row align-items-center">
                <p class="col-lg-6 text-lg-end">Total Licences:</p>
                <div class="col-lg-6">
                  <div class="input-group" style="max-width: 150px">
                    <button
                      class="btn btn-outline-secondary"
                      type="button"
                      (click)="
                        onLicenceChange(
                          summary.plan.requestedLicences - 1,
                          summary.plan.minimumLicences
                        )
                      "
                      [disabled]="summary.plan.requestedLicences <= summary.plan.minimumLicences"
                    >
                      -
                    </button>
                    <input
                      type="number"
                      class="form-control text-center"
                      [value]="summary.plan.requestedLicences"
                      [min]="summary.plan.minimumLicences"
                      (input)="
                        onLicenceChange(
                          $any($event.target).valueAsNumber,
                          summary.plan.minimumLicences
                        )
                      "
                      aria-label="Number of licences"
                    />
                    <button
                      class="btn btn-outline-secondary"
                      type="button"
                      (click)="
                        onLicenceChange(
                          summary.plan.requestedLicences + 1,
                          summary.plan.minimumLicences
                        )
                      "
                    >
                      +
                    </button>
                  </div>
                </div>
              </div>
               -->
              <div class="row align-items-center">
                <!-- <p class="col-lg-6 text-lg-end">Total Licences:</p> -->
                <p
                  class="col-lg-6 d-flex justify-content-lg-end justify-content-center align-items-center mb-0"
                >
                  Total Licences:
                </p>
                <!-- <div class="col-lg-6">
                  <div class="input-group input-group-sm" style="max-width: 120px">
                    <button
                      class="btn btn-outline-secondary btn-sm"
                      type="button"
                      (click)="
                        onLicenceChange(
                          summary.plan.requestedLicences - 1,
                          summary.plan.minimumLicences
                        )
                      "
                      [disabled]="summary.plan.requestedLicences <= summary.plan.minimumLicences"
                    >
                      -
                    </button>
                    <input
                      type="number"
                      class="form-control text-center"
                      [value]="summary.plan.requestedLicences"
                      [min]="summary.plan.minimumLicences"
                      (input)="
                        onLicenceChange(
                          $any($event.target).valueAsNumber,
                          summary.plan.minimumLicences
                        )
                      "
                      aria-label="Number of licences"
                    />
                    <button
                      class="btn btn-outline-secondary btn-sm"
                      type="button"
                      (click)="
                        onLicenceChange(
                          summary.plan.requestedLicences + 1,
                          summary.plan.minimumLicences
                        )
                      "
                    >
                      +
                    </button>
                  </div>
                </div> -->

                <!-- Stepper -->
                <div class="col-lg-6 d-flex justify-content-lg-start justify-content-center">
                  <div class="licence-stepper">
                    <!-- <button
                                type="button"
                                class="step-btn"
                                (click)="
                                  onLicenceChange(
                                    summary.plan.requestedLicences - 1,
                                    summary.plan.minimumLicences
                                  )
                                "
                                [disabled]="
                                  summary.plan.requestedLicences <= summary.plan.minimumLicences
                                "
                              >
                                <i class="ti ti-minus"></i>
                              </button> -->
                    <button
                      type="button"
                      class="step-btn"
                      (click)="onLicenceChange(-1, summary.plan.minimumLicences)"
                      [disabled]="licenceCount <= summary.plan.minimumLicences"
                    >
                      <i class="ti ti-minus"></i>
                    </button>

                    <!-- <div class="count">
                                {{ licenceCount }}
                              </div> -->

                    <div class="count">
                      <input
                        type="number"
                        class="licence-input"
                        [(ngModel)]="licenceCount"
                        (ngModelChange)="onLicenceInput($event, summary.plan.minimumLicences)"
                        [style.width]="((licenceCount || 0).toString().length || 1) + 2 + 'ch'"
                      />
                    </div>

                    <!-- <button
                                type="button"
                                class="step-btn"
                                (click)="
                                  onLicenceChange(
                                    summary.plan.requestedLicences + 1,
                                    summary.plan.minimumLicences
                                  )
                                "
                              >
                                <i class="ti ti-plus"></i>
                              </button> -->

                    <button
                      type="button"
                      class="step-btn"
                      (click)="onLicenceChange(1, summary.plan.minimumLicences)"
                    >
                      <i class="ti ti-plus"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="row mt-3">
                <p class="col-lg-6 text-lg-end">Used Licences:</p>
                <p class="col-lg-6 fw-bold">{{ summary.plan.usedLicences }}</p>
              </div>
              <div class="row">
                <p class="col-lg-6 text-lg-end">Minimum Licences:</p>
                <p class="col-lg-6 fw-bold">{{ summary.plan.minimumLicences }}</p>
              </div>
              <div class="row">
                <p class="col-lg-6 text-lg-end">Recurring Amount:</p>
                <p class="col-lg-6 fw-bold">
                  {{
                    summary.plan.recurringAmount
                      | currency: summary.billingSummary.currency : 'symbol' : '1.2-2'
                  }}
                </p>
              </div>
              <div class="row">
                <p class="col-lg-6 text-lg-end">Next Billing Date:</p>
                <p class="col-lg-6 fw-bold">
                  {{ summary.plan.nextBillingDate | date: 'mediumDate' }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-4 theiaStickySidebar h-100">
      <div class="card mt-4 me-4">
        <div class="card-body pt-4">
          <div class="d-flex justify-content-between border-bottom pb-2">
            <h2>Billing Summary</h2>
          </div>
          <!-- <div class="total-row pt-4">
            <div class="amount-due">
              <span class="label">Amount Payable</span>
              <span class="value">
                {{
                  summary.billingSummary.amountToBePaid
                    | currency: summary.billingSummary.currency : 'symbol' : '1.2-2'
                }}
              </span>
            </div>
          </div> -->

          <!-- Coupon -->
          <div class="mt-4">
            <div class="d-flex align-items-center justify-content-between">
              <!-- <label class="form-label fw-semibold mb-0">Coupon Code</label> -->
              <div class="d-flex align-items-center gap-2">
                <label class="form-label fw-semibold mb-0"> Coupon Code </label>

                <!-- Applied coupon -->
                <span *ngIf="appliedCoupon" class="badge bg-success">
                  {{ appliedCoupon }} (Applied)
                </span>
              </div>

              <button
                class="btn btn-sm"
                [ngClass]="showCouponInput ? 'btn-outline-danger' : 'btn-outline-primary'"
                (click)="toggleCouponInput()"
              >
                <i class="ti" [ngClass]="showCouponInput ? 'ti-x' : 'ti-plus'"></i>
                {{ showCouponInput || appliedCoupon ? 'Remove' : 'Add' }}
              </button>
            </div>

            <!-- Add click hone ke baad niche input field show hogi -->
            <div class="input-group mt-2" *ngIf="showCouponInput">
              <input
                type="text"
                class="form-control"
                [(ngModel)]="couponCode"
                placeholder="Enter Coupon"
              />

              <button class="btn btn-outline-primary" (click)="applyCoupon()">Apply</button>
            </div>
          </div>

          <div class="billing-details mt-4">
            <!-- License Amount -->
            <!-- <div class="billing-row">
                        <span class="label">
                          Amount ({{ summary.plan.requestedLicences }} Licenses)
                        </span>

                        <span class="value">
                          {{
                            summary.billingSummary.planProratedCharge *
                              summary.plan.requestedLicences
                              | currency: summary.billingSummary.currency : 'symbol' : '1.2-2'
                          }}
                        </span>
                      </div> -->
            <!-- Plan Prorated Price -->
            <div class="billing-row">
              <span class="label"> Plan Price (Per License) </span>

              <span class="value">
                {{
                  summary.billingSummary.planProratedCharge
                    | currency: summary.billingSummary.currency : 'symbol' : '1.2-2'
                }}
              </span>
            </div>

            <!-- License Count -->
            <div class="billing-row">
              <span class="label"> Licenses </span>

              <span class="value">
                {{ summary.plan.requestedLicences }}
              </span>
            </div>

            <!-- License Total -->
            <div class="billing-row">
              <span class="label"> License Amount </span>

              <span class="value">
                {{
                  summary.billingSummary.planProratedCharge * summary.plan.requestedLicences
                    | currency: summary.billingSummary.currency : 'symbol' : '1.2-2'
                }}
              </span>
            </div>

            <!-- Coupon -->
            <div class="billing-row discount" *ngIf="summary.billingSummary.couponDiscount > 0">
              <span class="label"> Coupon Discount </span>

              <span class="value">
                -
                {{
                  summary.billingSummary.couponDiscount
                    | currency: summary.billingSummary.currency : 'symbol' : '1.2-2'
                }}
              </span>
            </div>

            <!-- Taxable Amount -->
            <div class="billing-row">
              <span class="label"> Taxable Amount </span>

              <span class="value">
                {{
                  summary.billingSummary.taxableAmount
                    | currency: summary.billingSummary.currency : 'symbol' : '1.2-2'
                }}
              </span>
            </div>

            <!-- GST -->
            <div class="billing-row" *ngIf="summary.billingSummary.gstAmount > 0">
              <span class="label"> GST ({{ summary.billingSummary.gstRate }}%) </span>

              <span class="value">
                {{
                  summary.billingSummary.gstAmount
                    | currency: summary.billingSummary.currency : 'symbol' : '1.2-2'
                }}
              </span>
            </div>

            <hr />

            <!-- Payable -->
            <div class="billing-row total">
              <span class="label"> Amount Payable </span>

              <span class="value">
                {{
                  summary.billingSummary.amountToBePaid
                    | currency: summary.billingSummary.currency : 'symbol' : '1.2-2'
                }}
              </span>
            </div>
          </div>

          <!-- Autopay opt-in — sirf monthly plans ke liye relevant hai -->
          <div
            class="form-check mt-3"
            *ngIf="summary.plan.billingFrequency?.toLowerCase() === 'monthly'"
          >
            <input
              type="checkbox"
              class="form-check-input"
              id="wantsAutopay"
              [(ngModel)]="wantsAutopay"
            />
            <label class="form-check-label" for="wantsAutopay">
              Enable Autopay for future renewals
              <small class="d-block text-muted">
                You'll be asked to authorize auto-debit right after this payment.
              </small>
            </label>
          </div>

          <div class="d-grid mt-4">
            <button (click)="activateSubscription()" class="btn btn-primary" type="button">
              Pay Now
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loading>
  <div class="d-flex justify-content-center align-items-center p-5">
    <!--<p>Loading plan summary...</p>-->
  </div>
</ng-template>
